<script lang="ts">
  import type { PageData } from './$types';
  import { Track } from '$lib/models/track';
  import { translation } from '$lib/locale/locale';
  import { userContext } from '$lib/stores/stores';
  import TrackDetail from '$lib/ui/track-detail/track-detail.svelte';

  const { langHref, locale, t } = translation();
  const user = userContext.get();

  export let data: PageData;

  const schema = Track.GetSchema(data.asset, langHref);
  const breadcrumb = Track.GetBreadcrumb(data.asset, data.assetType, locale);
</script>

<svelte:head>
  {@html '<script type="application/ld+json">' + JSON.stringify(schema) + '</script>'}
  {@html '<script type="application/ld+json">' + JSON.stringify(breadcrumb) + '</script>'}
</svelte:head>

<!-- {#if data.init.flags.seasonal && (!$user || !$user?.subscription.isSubscribed)}
  <SpringBanner link={false} />
{/if} -->
<TrackDetail asset={data.asset} subscriptions={data.init.subscriptions} user={$user} />
